import dayjs from 'dayjs';

export const unixToDate = (aUnix: string | number) => {
  return dayjs.unix(Number(aUnix)).format('YY-MM-DD HH:mm:ss');
};

export const dateToUnix = (aData: any): number => {
  console.log(typeof aData);
  const re = dayjs(aData, 'YY-MM-DD HH:mm:ss').unix();
  return Number(re);
};
